import React from "react";
import DocumentList from "./DocumentList";

const Skjema: React.FC = () => {
    return <DocumentList documentType="SKJEMA" />;
};

export default Skjema;
